import { useState, useEffect } from "react";
import styles from "./list.module.css";
import { TextField, Button, Table, TableCell, TableHead, TableContainer, Paper, TableBody, TableRow, TableFooter, Dialog, DialogTitle, DialogContent, Snackbar, Alert } from "@mui/material";
import { StyledMainTableCell, StyledMainTableRow } from "../../components/TableComponent";
import TablePaginationComponent from "../../components/TablePagination";
import { Close } from "@mui/icons-material";
import axios from "axios";
import DeletePopup from "../../components/DeletePopup";
import Loader from "../../components/Loader";
import { TableLoader } from "../../components/ContentLoader";
import AddProductForm from "./AddSubscriptionForm";
import { authData, withAdminAuth } from "../../components/GetAuth";
import { Edit, Home, Search, Trash2, X } from "react-feather";

const SubscriptionList = () => {
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [formOpen, setFormOpen] = useState(false);
  const [filterVars, setFilterVars] = useState({ searchKey: "" });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [deleteModalOpen, setDeleteModalOpen] = useState();
  const [deleteId, setDeleteId] = useState(0);
  const [editData, setEditData] = useState(null);
  const auth = authData();
  const API_TOKEN = auth?.api_token;

  const paginationChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const paginationChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const fetchSubscriptions = () => {
      setContentLoading(true);
      axios.get(process.env.REACT_APP_API_URL + "v1/subscriptions", {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setContentLoading(false);
        setAllData(response.data.data);
      }).catch((error) => {
        setContentLoading(false);
      });
    };

    fetchSubscriptions();
  }, [API_TOKEN]);

  useEffect(() => {
    let filterredTempData = allData;

    if (filterVars?.searchKey !== "") {
      let inputVal = filterVars?.searchKey;
      inputVal = inputVal.toLowerCase();
      filterredTempData = filterredTempData.filter((item) => {
        return item.name.toLowerCase().includes(inputVal);
      });
    }

    setFilteredData(filterredTempData);
  }, [allData, filterVars]);

  const deleteConfirm = () => {
    setLoading(true);
    setDeleteModalOpen(false);
    axios.delete(process.env.REACT_APP_API_URL + "v1/subscriptions/" + deleteId, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);
        setSnackbarType("success");
        setAllData((prev) => {
          let temp = prev.filter((i) => i.id !== deleteId);
          return temp;
        });
        setDeleteId(0);
      }
      if (response.data.status === "ERROR") {
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);
        setSnackbarType("error");
      }
    }).catch((error) => {
      setLoading(false);
      if (error && error.response && error.response.data && error.response.data.messages) {
        setSnackbarOpen(true);
        setSnackbarMessage(error.response.data.messages);
        setSnackbarType("error");
      }
    });
  };

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <div className={`${styles.MainDiv}`}>
      <div className={`${styles.MainCard}`}>
        {contentLoading && <TableLoader />}

        {!contentLoading && (<div className={`${styles.PageTitleWrap}`}>
          <p className={`${styles.PageTitle}`}>Subscriptions List</p>
          <nav aria-label="breadcrumb">
            <ol className={`${styles.breadcrumb}`}>
              <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Subscriptions</li>
              <li className={`${styles.breadcrumbItem} ${styles.active}`}>List</li>
            </ol>
          </nav>
        </div>)}

        {!contentLoading && (<>
          <div className={`${styles.TableFilterHead}`}>
            <div className={`${styles.DataTableSearch}`}>
              <Search className={`${styles.SearchIcon}`} />
              <TextField id="search" type="text" placeholder="Search" aria-label="Search Input" value={filterVars?.searchKey} onChange={(e) => setFilterVars((prev) => { return { ...prev, searchKey: e.target.value }; })} />
              {filterVars?.searchKey !== "" && (<Button type="button" className={`${styles.CloseBU}`} onClick={(e) => setFilterVars((prev) => { return { ...prev, searchKey: "" }; })}><Close /></Button>)}
            </div>
          </div>

          <div className={`${styles.CusTable}`}>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <StyledMainTableCell>Name</StyledMainTableCell>
                    <StyledMainTableCell>Description</StyledMainTableCell>
                    <StyledMainTableCell>Monthly Amount</StyledMainTableCell>
                    <StyledMainTableCell>No Of Booking</StyledMainTableCell>
                    <StyledMainTableCell></StyledMainTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => {
                    return (<StyledMainTableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                      <TableCell component="th" scope="row" style={{ width: 200 }}>{item?.name}</TableCell>
                      <TableCell component="th" scope="row" style={{ width: 200 }}>{item?.description}</TableCell>
                      <TableCell component="th" scope="row" style={{ width: 120 }}>{item.monthly_amount ? (<>&pound; {parseFloat(item.monthly_amount).toFixed(2)}</>) : ("Free")}</TableCell>
                      <TableCell component="th" scope="row" style={{ width: 120 }}>{item.no_of_booking === 0 ? 'Unlimted' : item.no_of_booking}</TableCell>
                      <TableCell component="th" scope="row" align="right" style={{ width: 100 }}>
                        <Button onClick={(e) => { setFormOpen(true); setEditData(item); }} className={`${styles.TableActionBU}`}><Edit /></Button>
                        {item?.id !== 1 && <Button onClick={(e) => { setDeleteModalOpen(true); setDeleteId(item?.id); }} className={`${styles.TableActionBU}`}><Trash2 /></Button>}
                      </TableCell>
                    </StyledMainTableRow>);
                  })}
                  {filteredData.length === 0 && (<TableRow>
                    <TableCell colSpan={6} align="center">No data found</TableCell>
                  </TableRow>)}
                </TableBody>

                {filteredData.length > 0 && (<TableFooter>
                  <TableRow>
                    <TablePaginationComponent
                      count={filteredData.length}
                      colSpan={6}
                      page={page}
                      rowsPerPage={rowsPerPage}
                      handleChangePage={paginationChangePage}
                      handleChangeRowsPerPage={
                        paginationChangeRowsPerPage
                      }
                    />
                  </TableRow>
                </TableFooter>)}
              </Table>
            </TableContainer>
          </div>
        </>)}
      </div>
    </div>

    <Dialog
      open={formOpen}
      onClose={(e) => setFormOpen(false)}
      fullWidth
      maxWidth="xs"
      className={`${styles.NewPopUp}`}
    >
      <DialogTitle id="alert-dialog-title">
        {editData ? "Update Subscription" : "Add Subscription"}
        <button onClick={(e) => setFormOpen(false)}><X /></button>
      </DialogTitle>
      <DialogContent>
        <AddProductForm setFormOpen={setFormOpen.bind(this)} setAllData={setAllData.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} setSnackbarType={setSnackbarType.bind(this)} setLoading={setLoading.bind(this)} editData={editData} />
      </DialogContent>
    </Dialog>

    <DeletePopup open={deleteModalOpen} setOpen={setDeleteModalOpen.bind(this)} confirmAction={deleteConfirm.bind(this)} />

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={(e) => setSnackbarOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={(e) => setSnackbarOpen(false)}
        severity={snackbarType}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  </>);
};

export default withAdminAuth(SubscriptionList);